import Popup from "reactjs-popup";
import "./PopUp.scss";

export default function PopUp({
  children,
  openModal,
  setOpenModal,
  fullWidth = 0,
}: any) {
  const closeModal = () => setOpenModal(false);

  return (
    <Popup open={openModal} closeOnDocumentClick onClose={closeModal}>
      <div className={`modal ${fullWidth === 1 ? "full-width" : ""}`}>
        {children}
        <button className="close" onClick={closeModal}>
          &times;
        </button>
      </div>
    </Popup>
  );
}
